import { render } from "./PoliciesProcedures.vue?vue&type=template&id=01380ea6"
import script from "./PoliciesProcedures.vue?vue&type=script&lang=js"
export * from "./PoliciesProcedures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__